// extracted by mini-css-extract-plugin
export default {"input":"ResetPassword_input__XBFz+","errors":"ResetPassword_errors__+Y9Wt"};